interface EpisodeListProps {
  total: number;
  available: number;
  current: number | null;
  onSelect: (episode: number) => void;
}

export default function EpisodeList({ total, available, current, onSelect }: EpisodeListProps) {
  const episodes = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div>
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 flex items-center gap-2">
          <i className="ri-list-check-2 text-primary-600" />
          剧集列表
        </h3>
        <span className="text-xs md:text-sm text-foreground-500">
          已更新 {available} / 共 {total} 集
        </span>
      </div>

      <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-10 gap-2">
        {episodes.map((ep) => {
          const unlocked = ep <= available;
          const isActive = current === ep;
          return (
            <button
              key={ep}
              type="button"
              disabled={!unlocked}
              onClick={() => unlocked && onSelect(ep)}
              className={`h-10 rounded-md text-sm flex items-center justify-center transition-colors border ${
                isActive
                  ? 'bg-accent-500 border-accent-500 text-background-50'
                  : unlocked
                    ? 'bg-background-100 border-background-200 text-foreground-800 hover:border-primary-300 hover:text-primary-700 cursor-pointer'
                    : 'bg-background-100 border-background-200 text-foreground-300 cursor-not-allowed'
              }`}
            >
              {unlocked ? ep : <i className="ri-lock-line text-xs" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}